import { initializeApp, FirebaseApp } from "firebase/app";

const firebaseConfigProd = {
  apiKey: "AIzaSyBRdTB2OFzo6aYl_1USWWAi5egKxDgGYzg",
  authDomain: "simpl2-project.firebaseapp.com",
  projectId: "simpl2-project",
  storageBucket: "simpl2-project.appspot.com",
  messagingSenderId: "890441554514",
  appId: "1:890441554514:web:f937601c1c976ab3bedd8b",
  measurementId: "G-7YM2PWTHB6"
};

const firebaseConfigDev = {
  apiKey: "AIzaSyCEXj4Uv8xFvDxcz-gGJ-jIqvzrXKm4A8M",
  authDomain: "simpl2-dev.firebaseapp.com",
  projectId: "simpl2-dev",
  storageBucket: "simpl2-dev.appspot.com",
  messagingSenderId: "384681881768",
  appId: "1:384681881768:web:266849cd5b825c7514929d",
  measurementId: "G-CCCSP8B55Z"
};

let cachedApp: FirebaseApp | null = null;

/**
 * Chooses Firebase project (and thus Remote Config / message queue) by env.
 * Prod build must set REACT_APP_ENV to "production" or "prod" so this uses
 * simpl2-project; all other values use simpl2-dev.
 */
export const getFirebaseApp = () => {
  if (cachedApp) return cachedApp;
  const env = (process.env.REACT_APP_ENV ?? "").toLowerCase();
  const isProd = env === "production" || env === "prod";
  cachedApp = initializeApp(isProd ? firebaseConfigProd : firebaseConfigDev);
  return cachedApp;
};


